import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { DeliveryZoneDto, DeliveryZoneDtoListResponseMessage } from '@models/ropolo';
import { CreateDeliveryZonePayload } from '../models/payload/deliveryZone';
import { createDeliveryZones, getDeliveryZones, removeDeliveryZone } from '../services/deliveryZone';

// eslint-disable-next-line import/no-cycle
import { createAppAsyncThunk } from '../utils/reduxUtil';

interface DeliveryZonesStateInterface {
  loading: boolean;
  deliveryZones: Array<DeliveryZoneDto>;
}

const initialState: DeliveryZonesStateInterface = {
  loading: false,
  deliveryZones: [],
};

const getVendorDeliveryZones = createAppAsyncThunk<DeliveryZoneDtoListResponseMessage, void>(
  'deliveryZone/getVendorDeliveryZones',
  async () => {
    const response = await getDeliveryZones();
    return response;
  }
);

const createDeliveryZonesInput = createAppAsyncThunk<void, CreateDeliveryZonePayload>(
  'deliveryZone/createDeliveryZones',
  async (inputs, { dispatch }) => {
    await createDeliveryZones(inputs);
    await dispatch(getVendorDeliveryZones());
  }
);

const editDeliveryZonesInput = createAppAsyncThunk<void, CreateDeliveryZonePayload>(
  'deliveryZone/editDeliveryZones',
  async (input, { dispatch }) => {
    await createDeliveryZones(input);
    await dispatch(getVendorDeliveryZones());
  }
);

const deleteDeliveryZonesInput = createAppAsyncThunk<void, string>(
  'deliveryZone/editDeliveryZones',
  async (id, { dispatch }) => {
    await removeDeliveryZone(id);
    await dispatch(getVendorDeliveryZones());
  }
);

const deliveryZonesSlice = createSlice({
  name: 'deliveryZone',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<DeliveryZonesStateInterface>) => {
    builder.addCase(getVendorDeliveryZones.pending, (state) => ({
      ...state,
      loading: true,
    }));

    builder.addCase(getVendorDeliveryZones.fulfilled, (state, action) => ({
      ...state,
      loading: false,
      deliveryZones: action?.payload?.data || [],
    }));
    builder.addCase(getVendorDeliveryZones.rejected, (state) => ({
      ...state,
      loading: false,
    }));

    builder.addCase(createDeliveryZonesInput.pending, (state) => ({
      ...state,
      loading: true,
    }));

    builder.addCase(createDeliveryZonesInput.fulfilled, (state) => ({
      ...state,
      loading: false,
    }));
  },
});

export default deliveryZonesSlice;
export { createDeliveryZonesInput, deleteDeliveryZonesInput, editDeliveryZonesInput, getVendorDeliveryZones };
